<div [matTooltip]="tooltipText()" matTooltipClass="e-tooltip e-tab-tooltip">
    <mat-form-field>
        <mat-label>
            <span [ngClass]="{'bold-label': expiryStateService.selectedExpiryDate() !== null}">Expiry Date</span>
            <ng-container *ngIf="expiryStateService.selectedExpiryDate() as date">
                <ng-container *ngIf="date">
                    : {{ formatDate(date) }}
                </ng-container>
            </ng-container>
        </mat-label>
        <mat-select (click)="openDialog()"></mat-select>
    </mat-form-field>
</div>